import React from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../context/ToastContext";

const TestCard = ({ test, type }) => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  // 🧠 Handle navigation safely
  const handleStartTest = () => {
    if (!test?._id || !type) {
      showToast("Test ID or type missing!");
      return;
    }

    // Send timeLimit as route state
    navigate(`/tests/${type}/${test._id}`, { 
      state: { timeLimit: test.timeLimit }
    });
  };

  return (
    <div className="p-5 border rounded-2xl shadow-sm hover:shadow-xl transition-all bg-white">
      {/* 🏷️ Title */}
      <h2 className="text-xl font-semibold text-gray-800">
        {test.title}
      </h2>

      {/* 📄 Description */}
      <p className="text-gray-600 text-sm mt-1 line-clamp-2">
        {test.description || "No description provided."}
      </p>

      {/* 📊 Meta Info */}
      <div className="mt-3 space-y-1 text-sm text-gray-700">

        {/* ⭐ Show time limit only for timed tests */}
        {type === "timed" && test.timeLimit && (
          <div>
            <strong>Time Limit:</strong> {Math.floor(test.timeLimit / 60)} min
          </div>
        )}

        <div>
          <strong>Questions:</strong> {test.questions?.length || 0}
        </div>

        <div>
          <strong>Mode:</strong> {type?.toUpperCase() || "N/A"}
        </div>
      </div>

      {/* 🚀 Start Button */}
      <button
        onClick={handleStartTest}
        className="mt-4 w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium"
      >
        Start Test
      </button>
    </div>
  );
};

export default TestCard;
